/* esm.sh - jqueryui@1.11.1/jquery-ui.min */
export * from "/v135/jqueryui@1.11.1/esnext/jquery-ui.min.js";
export { default } from "/v135/jqueryui@1.11.1/esnext/jquery-ui.min.js";
